import { formatTime } from 'Utils';
import { t } from 'Locale/index';

const addCategoryWithSeparator = (category) => {
    if (!category) return '';
    return ` | ${category}`;
};

const addParentalRating = (metadata) => {
    const rating = metadata && metadata.getParentalRatingString();
    return rating ? ` | ${rating}` : '';
};

const createProgramTitle = (program, genreDataHide) => {
    if (genreDataHide) return `${program.getTitle()}`;

    return `${program.getTitle()}${addCategoryWithSeparator(program.getCategory())}`;
};

export const createLiveDescription = (program = {}, genreDataHide) => ({
    title: createProgramTitle(program, genreDataHide),
    startTime: formatTime(program.getStartTime())
});

export const createNextDescription = (program = {}, genreDataHide) => ({
    title: `${createProgramTitle(program, genreDataHide)}${addParentalRating(
        program.getMetaData()
    )}`,
    startTime: formatTime(program.getStartTime())
});

export const createAdultLockedDescription = (program = {}) => ({
    title: t('COMMON.LOCKED_ADULT_CONTENT'),
    startTime: formatTime(program.getStartTime())
});
